import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function DreamSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-24 px-4" style={{
    background: 'var(--color-bg)'
  }} data-id="element-65">
      <div className="max-w-2xl mx-auto" data-id="element-66">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7
      }} className="mb-10" data-id="element-67">
          <p className="text-sm font-semibold tracking-widest uppercase mb-6" style={{
          color: 'var(--color-accent)'
        }} data-id="element-68">
            Tu siguiente versión
          </p>

          <h2 className="text-3xl md:text-4xl font-black mb-6 leading-tight" style={{
          fontFamily: 'Playfair Display, serif',
          color: 'var(--color-text)'
        }} data-id="element-69">
            Ahora imagina esto.{' '}
            <span className="italic" style={{
            color: 'var(--color-accent)'
          }} data-id="element-70">
              No como fantasía. Como posibilidad real.
            </span>
          </h2>

          <p className="text-lg leading-relaxed" style={{
          color: 'var(--color-text-muted)'
        }} data-id="element-71">
            Imagina despertar un martes cualquiera…
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        delay: 0.3,
        duration: 0.8
      }} className="space-y-6 mb-12" data-id="element-72">
          <div className="flex items-start gap-4 p-6 rounded-sm" style={{
          background: 'var(--color-surface)',
          border: '1px solid var(--color-border)'
        }} data-id="element-73">
            <span className="text-2xl" data-id="element-74">🌅</span>
            <p className="text-lg leading-relaxed" style={{
            color: 'var(--color-text)'
          }} data-id="element-75">
              Sin esa sensación de ansiedad en el pecho que llega antes de que
              el despertador suene.
            </p>
          </div>

          <div className="flex items-start gap-4 p-6 rounded-sm" style={{
          background: 'var(--color-surface)',
          border: '1px solid var(--color-border)'
        }} data-id="element-76">
            <span className="text-2xl" data-id="element-77">🧠</span>
            <p className="text-lg leading-relaxed" style={{
            color: 'var(--color-text)'
          }} data-id="element-78">
              Sin la pregunta constante de "¿por qué no soy más de lo que soy?"
            </p>
          </div>

          <div className="flex items-start gap-4 p-6 rounded-sm" style={{
          background: 'var(--color-surface)',
          border: '1px solid var(--color-border)'
        }} data-id="element-79">
            <span className="text-2xl" data-id="element-80">🎯</span>
            <p className="text-lg leading-relaxed" style={{
            color: 'var(--color-text)'
          }} data-id="element-81">
              Con claridad absoluta sobre qué hacer primero — y por qué.
            </p>
          </div>

          <div className="flex items-start gap-4 p-6 rounded-sm" style={{
          background: 'var(--color-surface)',
          border: '1px solid var(--color-border)'
        }} data-id="element-82">
            <span className="text-2xl" data-id="element-83">💰</span>
            <p className="text-lg leading-relaxed" style={{
            color: 'var(--color-text)'
          }} data-id="element-84">
              Con una relación con el dinero que no te genera culpa cuando
              tienes y miedo cuando no tienes.
            </p>
          </div>

          <div className="flex items-start gap-4 p-6 rounded-sm" style={{
          background: 'var(--color-surface)',
          border: '1px solid var(--color-border)'
        }} data-id="element-85">
            <span className="text-2xl" data-id="element-86">⚡</span>
            <p className="text-lg leading-relaxed" style={{
            color: 'var(--color-text)'
          }} data-id="element-87">
              Con energía que no depende de motivación externa — porque viene de
              una alineación interna real.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 0.6,
        duration: 0.7
      }} data-id="element-88">
          <div className="space-y-2 mb-8" data-id="element-89">
            <p className="text-lg" style={{
            color: 'var(--color-text-muted)'
          }} data-id="element-90">
              Eso no es iluminación.
            </p>
            <p className="text-lg" style={{
            color: 'var(--color-text-muted)'
          }} data-id="element-91">
              No es suerte.
            </p>
            <p className="text-lg" style={{
            color: 'var(--color-text-muted)'
          }} data-id="element-92">
              No es magia.
            </p>
          </div>

          <div className="py-8 px-8 rounded-sm text-center" style={{
          background: 'var(--color-surface)',
          border: '1px solid var(--color-accent)'
        }} data-id="element-93">
            <p className="text-xl md:text-2xl font-bold leading-relaxed" style={{
            fontFamily: 'Playfair Display, serif',
            color: 'var(--color-text)'
          }} data-id="element-94">
              Es lo que ocurre cuando cambias tu sistema operativo mental y lo
              alineas con lo que realmente quieres construir.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}